import { useEffect } from 'react'
import {
  Network,
  MapPin,
  Radio,
  Tv,
  Bot,
  Sparkles,
  Users,
  MessageSquare,
  ExternalLink
} from 'lucide-react'

function NotreUniversPage() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const sites = [
    {
      icon: <Network size={24} color="#fff" />,
      title: 'JohnnySJH',
      badge: 'Le hub',
      desc: 'Story, news, IA, médias, association, réseau social, TV, radio et forum',
      gradient: 'linear-gradient(135deg, #ffd700, #ff8c00)',
      glow: 'rgba(255,180,0,0.35)',
      links: [
        { label: 'Site', url: 'https://johnny-network.web.app/accueil' }
      ]
    },
    {
      icon: <MapPin size={24} color="#fff" />,
      title: 'JohnnyGPS',
      badge: 'Carte en direct',
      desc: 'Retrouve les fans près de toi et partage tes trajets',
      gradient: 'linear-gradient(135deg, #00d9ff, #3d5aff)',
      glow: 'rgba(0,217,255,0.35)',
      links: [
        { label: 'Site', url: 'https://johnny-gps.web.app/' },
        {
          label: 'Play Store',
          url: 'https://play.google.com/store/apps/details?id=com.johnny.gps&hl=fr'
        }
      ]
    },
    {
      icon: <Radio size={24} color="#000" />,
      title: '100% Johnny',
      badge: '24/7',
      desc: 'La radio du Boss, en direct 24h/24',
      gradient: 'linear-gradient(135deg, #d4af37, #fff700)',
      glow: 'rgba(212,175,55,0.35)',
      links: [
        { label: 'Site', url: 'https://100pour100johnny.com' },
        {
          label: 'App Radio',
          url: 'https://play.google.com/store/apps/details?id=com.icreo.johnny100'
        },
        {
          label: 'App Site',
          url: 'https://play.google.com/store/apps/details?id=com.app_100pour100johnny.twa'
        }
      ]
    },
    {
      icon: <Tv size={24} color="#fff" />,
      title: 'JohnnyTV',
      badge: 'Streaming',
      desc: 'La chaîne TV dédiée à Johnny',
      gradient: 'linear-gradient(135deg, #ff3d81, #a83dff)',
      glow: 'rgba(255,61,129,0.35)',
      links: [
        { label: 'Site', url: 'https://johnnytv.fr' },
        {
          label: 'Play Store',
          url: 'https://play.google.com/store/search?q=johnnytv&c=apps'
        }
      ]
    },
    {
      icon: <Bot size={24} color="#000" />,
      title: 'JohnnyBOT',
      badge: 'Assistant IA',
      desc: 'Le chatbot IA pour discuter de Johnny',
      gradient: 'linear-gradient(135deg, #3dffb0, #00a8cc)',
      glow: 'rgba(61,255,176,0.35)',
      links: [
        { label: 'Site', url: 'https://johnnybot.fr' },
        {
          label: 'Play Store',
          url: 'https://play.google.com/store/apps/details?id=com.johnny.johnnybot'
        }
      ]
    },
    {
      icon: <Sparkles size={24} color="#fff" />,
      title: 'JohnnyXperience',
      badge: 'Immersif',
      desc: 'Une expérience immersive Johnny',
      gradient: 'linear-gradient(135deg, #ff8c00, #ff3d81)',
      glow: 'rgba(255,140,0,0.35)',
      links: [
        { label: 'Site', url: 'https://johnnyxperience.web.app' }
      ]
    },
    {
      icon: <Users size={24} color="#fff" />,
      title: "Rock'n Social",
      badge: 'Communauté',
      desc: 'La communauté des fans',
      gradient: 'linear-gradient(135deg, #ff3d81, #ff6b35)',
      glow: 'rgba(255,61,129,0.35)',
      links: [
        { label: 'Site', url: 'https://rocknsocial.fr' },
        {
          label: 'Play Store',
          url: 'https://play.google.com/store/apps/details?id=com.johnnynetwork.rocknsocial'
        }
      ]
    },
    {
      icon: <MessageSquare size={24} color="#fff" />,
      title: 'Johnny Talk',
      badge: 'Forum',
      desc: 'Le forum dédié à Johnny Hallyday : discutez entre fans, échangez pendant vos émissions en direct.',
      gradient: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
      glow: 'rgba(139,92,246,0.35)',
      links: [
        { label: 'Site', url: 'https://johnnytalk.fr' }
      ]
    }
  ]

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0a0a0a',
        color: '#fff',
        paddingBottom: '110px',
        boxSizing: 'border-box'
      }}
    >
      {/* HEADER */}
      <div
        style={{
          padding: '32px 20px 26px',
          background:
            'radial-gradient(ellipse at top, rgba(255,61,129,0.12), rgba(0,217,255,0.08) 55%, transparent 80%)',
          textAlign: 'center'
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '5px 14px',
            borderRadius: '20px',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            marginBottom: '14px'
          }}
        >
          <span
            style={{
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #ff3d81, #00d9ff)',
              animation: 'universePulseMobile 1.6s ease-in-out infinite'
            }}
          />
          <span
            style={{
              fontSize: '0.68rem',
              fontWeight: 800,
              letterSpacing: '1.5px',
              color: 'rgba(255,255,255,0.6)',
              textTransform: 'uppercase'
            }}
          >
            8 univers à explorer
          </span>
        </div>

        <h1
          style={{
            fontSize: '1.7rem',
            fontWeight: 900,
            margin: '0 0 8px',
            letterSpacing: '0.5px',
            background: 'linear-gradient(135deg, #ff3d81, #ffd700, #00d9ff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          NOTRE UNIVERS
        </h1>

        <p
          style={{
            fontSize: '0.85rem',
            color: 'rgba(255,255,255,0.5)',
            margin: 0,
            lineHeight: 1.5,
            maxWidth: '320px',
            marginInline: 'auto'
          }}
        >
          La radio n'est qu'une porte d'entrée — découvre tout ce qui fait vivre la famille Johnny
        </p>
      </div>

      {/* LISTE DES SITES */}
      <div
        style={{
          padding: '4px 16px 0',
          display: 'flex',
          flexDirection: 'column',
          gap: '14px'
        }}
      >
        {sites.map((site, index) => (
          <div
            key={`${site.title}-${index}`}
            style={{
              padding: '18px',
              background:
                'linear-gradient(160deg, rgba(255,255,255,0.045), rgba(255,255,255,0.015))',
              border: '1px solid rgba(255,255,255,0.09)',
              borderRadius: '20px',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {/* Lueur décorative */}
            <div
              style={{
                position: 'absolute',
                top: '-40%',
                right: '-20%',
                width: '160px',
                height: '160px',
                borderRadius: '50%',
                background: site.glow,
                filter: 'blur(45px)',
                opacity: 0.7,
                pointerEvents: 'none'
              }}
            />

            <div
              style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                marginBottom: '14px'
              }}
            >
              <div
                style={{
                  width: '52px',
                  height: '52px',
                  borderRadius: '15px',
                  background: site.gradient,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  boxShadow: `0 8px 24px ${site.glow}`
                }}
              >
                {site.icon}
              </div>

              <div style={{ minWidth: 0, paddingTop: '2px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    flexWrap: 'wrap'
                  }}
                >
                  <span
                    style={{
                      fontWeight: 800,
                      fontSize: '1.05rem'
                    }}
                  >
                    {site.title}
                  </span>

                  <span
                    style={{
                      fontSize: '0.6rem',
                      fontWeight: 800,
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase',
                      padding: '2px 9px',
                      borderRadius: '20px',
                      background: 'rgba(255,255,255,0.08)',
                      color: 'rgba(255,255,255,0.55)'
                    }}
                  >
                    {site.badge}
                  </span>
                </div>

                <div
                  style={{
                    fontSize: '0.82rem',
                    color: 'rgba(255,255,255,0.5)',
                    marginTop: '4px',
                    lineHeight: 1.4
                  }}
                >
                  {site.desc}
                </div>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
                position: 'relative'
              }}
            >
              {site.links.map((link, i) => (
                <a
                  key={`${link.url}-${i}`}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '9px 14px',
                    borderRadius: '13px',
                    fontSize: '0.78rem',
                    fontWeight: 700,
                    textDecoration: 'none',
                    color: '#fff',
                    background: 'rgba(255,255,255,0.07)',
                    border: '1px solid rgba(255,255,255,0.14)',
                    transition: 'transform 0.15s ease, background 0.15s ease'
                  }}
                  onTouchStart={(e) => {
                    e.currentTarget.style.transform = 'scale(0.96)'
                    e.currentTarget.style.background = 'rgba(255,255,255,0.14)'
                  }}
                  onTouchEnd={(e) => {
                    e.currentTarget.style.transform = 'scale(1)'
                    e.currentTarget.style.background = 'rgba(255,255,255,0.07)'
                  }}
                >
                  {link.label}
                  <ExternalLink size={12} />
                </a>
              ))}
            </div>
          </div>
        ))}

        {/* BIENTÔT */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            padding: '18px',
            background: 'rgba(255,255,255,0.02)',
            border: '1px dashed rgba(255,255,255,0.13)',
            borderRadius: '20px',
            marginTop: '2px'
          }}
        >
          <div
            style={{
              width: '52px',
              height: '52px',
              borderRadius: '15px',
              background: 'rgba(255,255,255,0.05)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '1.4rem',
              color: 'rgba(255,255,255,0.35)'
            }}
          >
            +
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontWeight: 800,
                fontSize: '1rem',
                color: 'rgba(255,255,255,0.75)'
              }}
            >
              Encore plus à venir
            </div>

            <div
              style={{
                fontSize: '0.8rem',
                color: 'rgba(255,255,255,0.4)',
                marginTop: '2px'
              }}
            >
              D'autres univers Johnny arrivent bientôt
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes universePulseMobile {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.5);
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  )
}

export default NotreUniversPage